import Ads from "../../modules/home/partials/Ads";
import { Outlet } from "../../../node_modules/react-router-dom/dist/index";

const AdsWrapper = () => {
	return (
		<section className="section-box">
			<div className="container-fluid banner-hero hero-1">
				<Ads adsType="left" />
				<div className="search_area">
					<div className="row">
						<div className="col-12">
							<Outlet />
						</div>
					</div>
				</div>
				<Ads adsType="right" />
			</div>
		</section>
	);
};

export default AdsWrapper;
